export const itemsItemCategory = [
    { value: "1", label: "Computers & Electronics" },
    { value: "2", label: "Computers & Electronics 2" }
  ];

export const BomAttributeData = [
    { "defaultZone": " Zone 1",
      "minStockLevel": 50, 
      "maxStockLevel": 100, 
      "suggStockLevel": 342331, 
      "itempopularity": " High Velocity (A)", 
      "FLMethod": " FEFO ", 
      "description": " Date Received", 
      "countryOrigin": " US ", 
      "shelfLife": " 60 Days", 
      "shipLife": " 30 Days"
    }
];
export const BomInformationData = [
    { "itemCode": 233323,
      "itemDescription": "Xbox", 
      "itemExtendedDescription": "Handle With Care", 
      "EANcode": 123456, 
      "salePrice": " $ 349.99", 
      "baseCost": " $ 100.00", 
      "averageCost": " $ 100.00", 
      "itemImage": " Zone 1"
    }
];

export const itemsItemGroup = [
    { value: "1", label: "Group A" },
    { value: "2", label: "Group B" },
    { value: "3", label: "Group C" }
];

export const itemsManufacturer = [
    { value: "1", label: "Group A" },
    { value: "2", label: "Group B" },
    { value: "3", label: "Group C" }
  ];

  export const selectedComponent = [
    { itemCode: 'CT1254',  Qty: 2, itemDescription: 'iPhone 14' ,itemtype:'Assembly'},
   ];

   export const bomSelectComponentItemCode=[
      { item: 'CH12456', description: 'Controller', itemtype:'Assembly'},
      { item: 'TB23455', description: 'Console',itemtype:'Assembly'},
      { item: 'Ip12344', description: 'Mac Book',itemtype:'Components'},
  
]

export const dropDownItemCode_bomEdit = [
  { value: 'IP-23339', label: 'IP-23339' },
  { value: 'IT-23229', label: 'IT-23229' },
  { value: 'IR-29539', label: 'IR-29539' }
]

export const typeOfKitOptions = [
  { value: '1', label: "Kit To Stock" },
  { value: '2', label: "QC Hold" },
  { value: '3', label: "Damaged" },
  { value: '4', label: "Finished Goods" }
]

export const initialData_EditCode = [
  { itemCode: 'CT1254',  Qty: 2, itemDescription: 'iPhone 14' },
  { itemCode: 'TB154478',  Qty: 1, itemDescription: 'Mac book' },
]